import { render, staticRenderFns } from "./AxCreateProject.vue?vue&type=template&id=0d6723ce&"
import script from "./AxCreateProject.vue?vue&type=script&lang=ts&"
export * from "./AxCreateProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports